import moment from "moment";

const isLatestRequestActual = (latestDate) => {
  const lateDate = moment(latestDate).add(10, "minutes");

  return moment(latestDate).isBefore(lateDate);
};

export {
  isLatestRequestActual
}